import {DecimalPipe} from '@angular/common';
import {Component, ElementRef, OnInit, inject} from '@angular/core';
import {Router, NavigationEnd, ActivatedRoute} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {ConfirmationService, MenuItem} from 'primeng/api';
import {PrimeNG} from 'primeng/config';
import {LocalizedDatePipe} from '../components/LocalizedDatePipe';
import {UserErrors} from '../models';
import {MiniBookAdminService} from '../service/mini-book-admin.service';

@Component({
    selector: 'edu-udo-itmc-dev-mini-book-administration',
    templateUrl: './administration.component.html',
    styleUrls: ['./administration.component.css'],
    providers: [
        ConfirmationService,
        LocalizedDatePipe,
        DecimalPipe
    ],
    standalone: false
})
export class AdministrationComponent implements OnInit {

  tabItems: MenuItem[] = [];
  generalConfigErrors?: UserErrors;
  activeTab: string = 'generalConfig';
  private primeng = inject(PrimeNG);

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private adminService: MiniBookAdminService,
    private translate: TranslateService,
    private elementRef: ElementRef
  ) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.activeTab = this.getActiveTabFromUrl();
      }
    });
  }

  private getActiveTabFromUrl(): string {
    const match = this.router.url.match(/#\/([^/\?#]+)/);
    if (match) {
      const tabValue = match[1].split('/')[0];
      return this.tabItems.find(item => item.value === tabValue)?.value || 'generalConfig';
    }
    return 'generalConfig';
  }

  ngOnInit(): void {
    this.activeTab = this.getActiveTabFromUrl();
    this.adminService.tenant = this.elementRef.nativeElement.getAttribute('tenant');

    this.tabItems = [
      {label: 'Einstellungen', value: 'generalConfig', routerLink: '/generalConfig'},
      {label: 'Zeitslots', value: 'timeslots', routerLink: '/timeslots'},
      {label: 'Orte', value: 'rooms', routerLink: '/rooms'},
      {label: 'Tags', value: 'tags', routerLink: '/tags'},
      {label: 'Stundenplan', value: 'timetableEntries', routerLink: '/timetableEntries'},
      {label: 'Teilnehmer', value: 'attendees', routerLink: '/attendees'}
    ]

    this.adminService.generalConfig.getGeneralConfig().subscribe({
      next: generalConfig => {
        if (generalConfig && generalConfig.workshopName) {
          this.translate.set('WORKSHOP', generalConfig.workshopName);
        }
        if (generalConfig && generalConfig.infoName) {
          this.translate.set('INFO', generalConfig.infoName);
        }
        if (generalConfig && generalConfig.breakName) {
          this.translate.set('BREAK', generalConfig.breakName);
        }
      },
      error: err => {
        if ('error' in err && typeof err.error == 'object' && 'type' in err.error && err.error.type === 'UserErrors') {
          this.generalConfigErrors = err.error;
        } else {
          const message: any = {
            type: 'PlainErrorMessage',
            summary: 'Fehler bei der Kommunikation mit dem Backend',
            detail: err.message
          };
          this.generalConfigErrors = {
            type: 'UserErrors',
            messages: [message]
          };
        }
      }
    });
  }
}
